import { Page, LinkButton, ExternalLinkIcon } from '@/components';
import AllocationTable from './AllocationTable';
import OverviewKpis from './OverviewKpis';
import { Flex } from '@blockanalitica/ui';

export default function MorphoPage() {
  return (
    <Page
      title="Spark DAI Vault Morpho"
      actions={
        <>
          <LinkButton
            to="https://morpho.blockanalitica.com/ethereum/metamorpho/vaults/0x73e65dbd630f90604062f6e02fab9138e713edd9"
            target="_blank">
            <Flex
              gap="3xs"
              alignItems="center"
              style={{ whiteSpace: 'nowrap' }}>
              Morpho DAI Details <ExternalLinkIcon size="1" />
            </Flex>
          </LinkButton>
        </>
      }>
      <OverviewKpis daysAgo={1} />
      <AllocationTable daysAgo={1} />
    </Page>
  );
}
